import { _values, tsValidateArray, tsValidateBoolean, tsValidateDynamicObject, tsValidateNumber, tsValidateOptionalId, tsValidateOptionalObject, tsValidateString, tsValidateTimestamp, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { ApprovalSource_Enum, RuntimeOrderSource_Enum, RuntimeOrderStatus_Enum } from './consts.js';
import { AdvisorRuntimeIDBGroup, Validator_EncounterId } from '../_core/index.js';
const Validator_ModifiableProps = {
    ...Validator_EncounterId,
    orderId: tsValidateUniqueId,
    orderStatus: tsValidateValue(_values(RuntimeOrderStatus_Enum)),
    ehrOrderId: tsValidateOptionalId,
    timeAccepted: tsValidateTimestamp(undefined, false),
    isPrecondition: tsValidateBoolean(),
    fhirId: tsValidateString(undefined, false), // the fhir id is a UniqueId, but it's not in our 32 hex format so validate it as string
    timeCreated: tsValidateNumber(),
    timeResulted: tsValidateNumber(false),
    orderSource: tsValidateValue(_values(RuntimeOrderSource_Enum)),
    protocolMapping: tsValidateDynamicObject(tsValidateArray(tsValidateUniqueId), tsValidateUniqueId, false),
    orderGroup: tsValidateArray(tsValidateUniqueId, false),
    extraMetadata: tsValidateOptionalObject({ rejected: tsValidateBoolean(false) }),
    approvedSource: tsValidateValue(_values(ApprovalSource_Enum)),
};
const Validator_GeneratedProps = {
    _auditorId: tsValidateString(undefined, false)
};
export const DBDef_RuntimeOrder = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'runtime-orders',
    entityName: 'RuntimeOrder',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'runtime-order'
    },
    backend: {
        name: 'runtime-orders'
    }
};
//# sourceMappingURL=db-def.js.map